import './SupplyCard.css';

export interface SupplyItem {
  id: string;
  category: string;
  title: string;
  description: string;
  affiliateUrl: string;
  iconName?: string;
  vendorLabel?: string;
}

interface SupplyCardProps {
  item: SupplyItem;
  onPress: () => void;
  className?: string;
}

/**
 * SEO-optimized supply card component
 */
export function SupplyCard({ item, onPress, className = '' }: SupplyCardProps) {
  const vendorText = `View on ${item.vendorLabel || 'Amazon'}`;

  return (
    <article className={`supply-card ${className}`}>
      <a
        href={item.affiliateUrl}
        onClick={(e) => {
          e.preventDefault();
          onPress();
        }}
        className="supply-card-link"
        rel="nofollow sponsored"
        aria-label={`${item.title}, ${item.description}`}
      >
        <div className="supply-card-content">
          {item.iconName && (
            <div className="supply-card-icon" aria-hidden="true">
              {getIconEmoji(item.iconName)}
            </div>
          )}
          <div className="supply-card-text">
            <h3 className="supply-card-title">{item.title}</h3>
            <p className="supply-card-description">{item.description}</p>
            <span className="supply-card-vendor">{vendorText}</span>
          </div>
        </div>
      </a>
    </article>
  );
}

function getIconEmoji(iconName: string): string {
  const iconMap: Record<string, string> = {
    'medical-outline': '💉',
    'water-outline': '💧',
    'bandage-outline': '🩹',
    'flask-outline': '🧪',
    'trash-outline': '🗑️',
    'snow-outline': '❄️',
  };
  return iconMap[iconName] || '📦';
}

